import service from '../utils/request'
// 查询列表
export const query = params => { return service.post(`/api/base_brand/query`, params) };
// 创建
export const create = params => { return service.post(`/api/base_brand/create`, params) };
// 修改
export const edit = params => { return service.put(`/api/base_brand/edit`, params) };
// 删除
export const deleted = params => { return service.delete(`/api/base_brand/delete`, { params }) };
//根据Id获取会员信息
export const getmemberbyid = params => { return service.get(`/api/member_info/getmemberbyid`, { params }) };
//根据会员动态码获取会员信息
export const getmemberbydynamic = params => { return service.get(`/api/member_info/getmemberbydynamic`, { params }) };
// 充值余额
export const rechargebalance = params => { return service.post(`/api/base_brand/rechargebalance`, params) };
// 会员消费记录
export const GetConsumeByBrandId = params => { return service.post(`/api/base_brand/GetConsumeByBrandId`, params) };
// 余额明细
export const GetBalanceDetailByBrandId = params => { return service.post(`/api/base_brand/GetBalanceDetailByBrandId`, params) };
// 查询支付信息
export const payresultquery = params => { return service.get(`/api/base_brand/payresultquery`, { params }) };
// 余额记录
export const GetBalanceRecord = params => { return service.post(`/api/base_brand/GetBalanceRecord`, params) };

// 余额记录
export const GetBalanceRecordNew = params => { return service.post(`/api/base_brand/GetBalanceRecordNew`, params) };


